import axios from '@axios'

/** 
* Índice
* {@link getGrades} - Obtener notas
* {@link getEvaluation} - Obtener nota
* {@link createEvaluation} - Intentar ir quitando os sitios que usan isto
* {@link addEvaluation} - Crear nota
* {@link deleteEvaluation} - Eliminar nota
* {@link updateEvaluation} - Actualizar nota
*/

    /**
     * Obtener todads las notas
     * @param {*} queryParams 
     * @returns evaluations 
     */
    export const getGrades = function (queryParams) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .get('/grades', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Obtener nota
     * @param {integer} id ID de la nota 
     * @returns evaluation
     */

    export const getGrade = function ( id ) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/grades/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Añadir nota
     * @param {*} data Datos del cliente 
     * @returns 
     */

    export const addGrade = function (data) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/grades`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Borrar nota
     * @param {integer} id ID de la nota a borrar
     * @returns 
     */

    export const deleteGrade = function ({ id }) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/grades/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Actualizar nota
     * @param {integer} id ID de la nota a actualizar 
     * @returns 
     */

    export const updateGrade = function (data) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/grades/${data.id}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }










